import { twMerge } from 'tailwind-merge';
import { Button, ButtonProps } from './Button';

type Option<T> = {
  label: string;
  value: T;
};

type RadioButtonsProps<T> = {
  value: T;
  size?: ButtonProps['size'];
  style?: 'dark' | 'light';
  onChange: (value: T) => void;
  options: Option<T>[];
  className?: string;
};

export function RadioButtons<T>(props: RadioButtonsProps<T>) {
  const { className, options, value, onChange, style = 'light', size } = props;

  const activeStyle = style === 'light' ? 'neutral' : 'outline-dark';
  const inactiveStyle = style === 'light' ? 'outline' : 'neutral-dark';

  const classNames = twMerge(
    'hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)] hover:text-white',
    className
  );
  return (
    <div className='flex flex-row gap-2'>
      {options.map((option) => {
        return (
          <Button
            size={size}
            className={classNames}
            key={option.value + option.label}
            style={value === option.value ? activeStyle : inactiveStyle}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
